import { DropdownOption } from '@app/components/ui/Dropdown';

export const ROLES = {
  PROPERTY_OWNER: 'Chủ sở hữu',
  ESTATE_AGENT: 'Môi giới',
};

export const DROPDOWN_OPTIONS: DropdownOption[] = [
  {
    value: 'PROPERTY_OWNER',
    label: 'Chủ sở hữu',
  },
  {
    value: 'ESTATE_AGENT',
    label: 'Môi giới',
  },
];
